const UNAVAILABLE_FOCUS_STATE = {
    isFocusable: false,
    isFocused: false,
    activeElementIsPreviousInput: false,
};
export function getInputFocusState(editorElement) {
    if (editorElement == null) {
        return UNAVAILABLE_FOCUS_STATE;
    }
    const activeElement = document.activeElement;
    const isActiveElement = activeElement instanceof HTMLElement;
    const editorElementId = editorElement.id;
    const style = window.getComputedStyle(editorElement);
    return {
        isFocusable: style.display !== 'none' &&
            style.visibility === 'visible' &&
            !editorElement.closest('[aria-hidden="true"]') &&
            !editorElement.closest('[inert]'),
        isFocused: activeElement === editorElement || editorElement.contains(activeElement),
        activeElementIsPreviousInput: isActiveElement &&
            activeElement !== editorElement &&
            editorElementId !== '' &&
            activeElement.id === editorElementId,
    };
}
//# sourceMappingURL=inputFocusState.js.map